<template>
  <h2>{{nome}}</h2>
  <span class="linha_orgaos darkbackground"
        :class="faculdadename"></span>
</template>

<script>
export default {
  name: "TitleWithLine",
  props:["nome","faculdadename"]
}
</script>

<style scoped>
h2 {
  display: inline-block;
  margin-bottom: 10px;
  text-align: left;
  color: rgb(87,88,89);
  font-size: 26px;
  font-family: "Montserrat Semibold";
  margin-bottom: 6px;
  padding-top: 70px;
}

.linha_orgaos {
  height: 3px;
  display: block;
  width: 140px;
  margin-bottom: 25px;
}



@media (min-width : 768px) and (max-width : 1024px) {
  h2 {
    font-size: 23px;
    padding-top: 45px;
    padding-left: 10px;
  }

  .linha_orgaos {
    height: 3px;
    margin-left: 10px;
  }
}

@media (max-width: 767px){
  h2 {
    font-size: 17px;
    padding-top: 30px;
    padding-left: 10px;
  }

  .linha_orgaos {
    height: 3px;
    margin-bottom: 15px;
    margin-right: 0!important;
    margin-left: 10px;
  }
}

</style>